module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( feedback === "success" ) { 
__p+=' <fieldset><h4>'+
((__t=( i18n.tc("UnitFeedback", "Testing completed") ))==null?'':__t)+
'</h4><p class="fold">'+
((__t=( i18n.tc("UnitFeedback", "Review the test results and correct any errors. You may either test again, or confirm the results by continuing.") ))==null?'':__t)+
' </p></fieldset> ';
 if ( showTestedBoth ) { 
__p+=' <fieldset><p><input type="checkbox" id="tested-both-input" data-input="tested-both" value="yes"> <label class="align-left no-ellipsis" for="tested-both-input">'+
((__t=( i18n.tc( "UnitFeedback", "The device was tested both with and without 230 V connected." ) ))==null?'':__t)+
'</label></p></fieldset> ';
 } 
__p+=' <fieldset class="button-wrap"><button data-click="feedback-retest">'+
((__t=( i18n.tc("UnitFeedback", "Re-test device") ))==null?'':__t)+
'</button> <button class="primary" data-click="feedback-close" '+
((__t=( ( showTestedBoth ) ? " disabled" : "" ))==null?'':__t)+
'>'+
((__t=( i18n.tc("UnitFeedback", "Continue") ))==null?'':__t)+
'</button></fieldset> ';
 } 
__p+=' ';
 if ( feedback === "warning" ) { 
__p+=' <fieldset><h4>'+
((__t=( i18n.tc("UnitFeedback", "Sub-par results") ))==null?'':__t)+
'</h4><p class="fold">'+
((__t=( i18n.tc("UnitFeedback", "Review the test results, correct any errors and test again. Since some of the test results failed you must log in as an installer to proceed without correcting errors.") ))==null?'':__t)+
'</p></fieldset> ';
 if ( showTestedBoth ) { 
__p+=' <fieldset><p><input type="checkbox" id="tested-both-input" data-input="tested-both" value="yes"> <label class="align-left no-ellipsis" for="tested-both-input">'+
((__t=( i18n.tc( "UnitFeedback", "The device was tested both with and without 230 V connected." ) ))==null?'':__t)+
'</label></p></fieldset> ';
 } 
__p+=' <fieldset class="button-wrap"><button data-click="feedback-retest">'+
((__t=( i18n.tc("UnitFeedback", "Re-test device") ))==null?'':__t)+
'</button> <button class="primary" data-click="feedback-verify" '+
((__t=( ( showTestedBoth ) ? " disabled" : "" ))==null?'':__t)+
'>'+
((__t=( i18n.tc("UnitFeedback", "Continue") ))==null?'':__t)+
'</button></fieldset> ';
 } 
__p+=' ';
 if ( feedback === "error" ) { 
__p+=' <fieldset><h4>'+
((__t=( i18n.tc("UnitFeedback", "One or more tests have failed.") ))==null?'':__t)+
'</h4><p class="fold">'+
((__t=( i18n.tc("UnitFeedback", "Please review the information above and try testing the device again.") ))==null?'':__t)+
'</p></fieldset><fieldset class="button-wrap"><button class="primary" data-click="feedback-retest">'+
((__t=( i18n.tc("UnitFeedback", "Re-test device") ))==null?'':__t)+
'</button></fieldset> ';
 } 
__p+='';
}
return __p;
};
